import { unparse as convertToCSV } from 'papaparse';
import { FilterOption } from '../types/types';

const download = (data: any, fileTitle: string) => {
  // Creating a Blob for having a csv file format
  // and passing the data with type
  const blob = new Blob([data], { type: 'text/csv' });

  // Creating an object for downloading url
  const url = window.URL.createObjectURL(blob);

  // Creating an anchor(a) tag of HTML
  const a = document.createElement('a');

  // Passing the blob downloading url
  a.setAttribute('href', url);

  // Setting the anchor tag attribute for downloading
  // and passing the download file name
  a.setAttribute('download', fileTitle);

  // Performing a download with click
  a.click();
};

const normalizeKey = (key: string) => {
  if (key.length === 0) { return key; }
  const newS = key[0].toUpperCase() + key.substring(1).replace(/([A-Z])/g, ' $1').trim();
  return newS;
};

const stringifyExportObject = (obj: any) => {
  if (obj.B2B !== undefined) {
    return [`B2B: ${obj.B2B}`, `B2C: ${obj.B2C}`, `B2G: ${obj.B2G}`, `SaaS: ${obj.SaaS}`].join('\n');
  }

  if (obj.industry !== undefined) {
    return obj.industry;
  }

  if (obj.worldRegion !== undefined) {
    let base = obj.worldRegion;
    if (obj.country) {
      base = `${obj.country}`;
    }
    if (obj.state) {
      base = `${obj.state}`;
    }

    return base;
  }

  return JSON.stringify(obj);
};

const normalizeExportData = (data: any) => {
  if (Array.isArray(data)) {
    const someArray: any[] = data;
    return someArray.map((obj) => stringifyExportObject(obj)).join('\n');
  }
  if (typeof data === 'object' && data !== null) {
    return stringifyExportObject(data);
  }
  return data;
};

export const exporter = async (input: any[], excluding: string[], title: string) => {
  if (input.length === 0) {
    return;
  }

  const cleaned = input.map((inv) => Object.fromEntries((Object.entries(inv).filter((entry) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const [key, _] = entry;
    return !excluding.includes(key);
  })
  )));

  const fields = Object.keys(cleaned[0]).map((k) => normalizeKey(k));
  const data = cleaned.map((mi) => Object.values(mi).map((val) => normalizeExportData(val)));
  const csv = convertToCSV({
    data,
    fields
  });
  download(csv, title);
};

export default exporter;

/* eslint-disable arrow-body-style */
export const formikSubmitDisabled = (formik: any) => {
  const { isValid, isSubmitting } = formik;
  return (!isValid || isSubmitting);
};
const oneMil = 1000000.0;
export const dollarFormatInstruction = '(in dollars)';
export const tbd = 'Missing required info';
export const optionalInfo = 'Missing info (optional)';

export const convertDollarsToMillions = (amountInDollars: number) => {
  const inMils = amountInDollars / oneMil;
  return Math.round(inMils * 100 + Number.EPSILON) / 100;
};
export const convertMillionsToDollars = (amountInMillions: number) => amountInMillions * oneMil;
export const formatDollarsAsMillions = (amountInDollars: number, noUnits: boolean = false) => {
  const inMils = convertDollarsToMillions(amountInDollars);
  return noUnits ? `${inMils}` : `$${inMils}M`;
};

export const wholeDollarsOmitTrailingZeros = (amountInMillions: number) => {
  return Number(Number(amountInMillions).toFixed(0));
};

export const filterOptionsAreSame = (options1: FilterOption[], options2: FilterOption[]) => {
  if (options1.length === options2.length) {
    const sorted1 = options1.sort((a, b) => ((a.key <= b.key) ? -1 : 1));
    const sorted2 = options2.sort((a, b) => ((a.key <= b.key) ? -1 : 1));
    let same = true;

    options1.forEach((option1, idx) => {
      const option2 = options2[idx];
      same = same && option1.query === option2.query && option1.key === option2.key;
    });

    return same;
  }
  return false;
};
